export default "__VITE_ASSET__BP3WyiF___"